import { render, staticRenderFns } from "./MovimientosTabContent.vue?vue&type=template&id=ff2992ba&scoped=true"
import script from "./MovimientosTabContent.vue?vue&type=script&lang=js"
export * from "./MovimientosTabContent.vue?vue&type=script&lang=js"
import style0 from "./MovimientosTabContent.vue?vue&type=style&index=0&id=ff2992ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2992ba",
  null
  
)

export default component.exports